import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import axiosInstance from "../../../lib/axios";
import {
  Box, Grid, Button, TextField, Typography, Paper, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, FormControl, InputLabel,
  Select, MenuItem, Autocomplete, FormHelperText, Checkbox
} from "@mui/material";
import {
  Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon,
} from "@mui/icons-material";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UnLock from "../../../GlobalFunction/UnLock";
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import { getRoomMasterdropdata } from '../../../Api/PropertyMst/Api'
import LastRateDialog from './LastRateDialog';
import InsertLinkIcon from '@mui/icons-material/InsertLink';

const GRNStep2 = ({
  TableData, mode, Cities, setTableData, AllfieldStepperData, GooodsId,
  setActiveStep, fetchGoodsData, viewModeDis, addModeDis, setFlag,
  IsButtonSubmit, UserLoginId, TextDisabledFast
}) => {
  const { register, watch, reset, setValue } = useForm({
    defaultValues: {
      ItmCatId: "",
      ItmGrpId: "",
      ItmSubGrpId: "",
      ItmId: "",
      Quantity: "",
      Rate: "0.00",
      Amount: "0.00",
      UnitId: "",
      Remark: "",
      mode: 'onChange',
    }
  });
  console.log('AllfieldStepperData', AllfieldStepperData)
  const userId = sessionStorage.getItem('UserId');
  const [AllTextDisabled, setAllTextDisabled] = useState(true);
  const [AllButtonDisabled, setAllButtonDisabled] = useState(true);
  const [IndexofSelect, setIndexofSelect] = useState(-1);
  const [InternalMode, setInternalMode] = useState("add");
  const [AddDisabled, setAddDisabled] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [CategoryDrp, setCategoryDrp] = useState([]);
  const [categorySelected, setCategorySelected] = useState(false);
  const [ItmDrp, setItmDrp] = useState([]);
  const [GroupDrp, setGroupDrp] = useState([]);
  const [SubGrpdrp, setSubGrpdrp] = useState([]);
  const [Unitdrp, setUnitdrp] = useState([]);
  const divRef = useRef(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [columnFilters, setColumnFilters] = useState({});
  const [searchText, setSearchText] = useState("");
  const [propoption, setPropoption] = useState([])
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [lastRate, setLastRate] = useState('$12.50');
  const [lastRateData, setLastRateData] = useState([]);
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  const columns = [
    { id: "ItmCatName", label: "Category", minWidth: 50 },
    { id: "ItmGrpName", label: "Group", minWidth: 50 },
    { id: "ItmSubGrpName", label: "SubGroup", minWidth: 50 },
    { id: "ItmName", label: "Item", minWidth: 50 },
    { id: "UnitName", label: "Unit", minWidth: 50 },
    { id: "Quantity", label: "Qty", minWidth: 50 },
    { id: "Rate", label: "Rate", minWidth: 50 },
    { id: "Amount", label: "Amount", minWidth: 50 },
  ];
  console.log('reset', TableData)
  const filterTableData = (data) => {
    return data?.filter(row => {
      if (row.DBFLAG === "D") return false;
      return Object.keys(columnFilters).every(key => {
        if (!columnFilters[key]) return true;

        const cellValue = String(row[key] || "").toLowerCase();
        return cellValue.includes(columnFilters[key].toLowerCase());
      });
    });
  };
  useEffect(() => {
    fetchUnits();
    fetchCategoryData();
  }, []);
  const handlePropertyChange = (event, newValue) => {
    setSelectedProperty(newValue);
  };
  useEffect(() => {
    if (TableData?.length > 0 && IndexofSelect === -1) {
      setIndexofSelect(0);
    }
  }, [TableData]);

  useEffect(() => {
    if (TableData?.length > 0 && IndexofSelect >= 0) {
      const selectedRow = TableData[IndexofSelect];
      if (selectedRow) {
        if (AllTextDisabled) {
          setGroupDrp([]);
          setSubGrpdrp([]);
          setItmDrp([]);
          reset({
            ItmCatId: selectedRow.ItmCatId,
            ItmGrpId: selectedRow.ItmGrpId,
            ItmSubGrpId: selectedRow.ItmSubGrpId,
            ItmId: selectedRow.ItmId,
            Quantity: selectedRow.Quantity,
            Rate: selectedRow.Rate,
            Amount: selectedRow.Amount,
            UnitId: selectedRow.UnitId,
            Remark: selectedRow.Remark,
          });
          const populateDropdowns = async () => {
            try {
              const groupResponse = await axiosInstance.post(
                "MstItmGrp/GetMstItmGrpdrp",
                { ItmCatId: selectedRow.ItmCatId, Flag: "" }
              );
              if (groupResponse.data.Status === 0) {
                setGroupDrp(groupResponse.data.Data);

                const subGroupResponse = await axiosInstance.post(
                  "MstItmSubGrp/GetMstItmSubGrpdrp",
                  { ItmGrpId: selectedRow.ItmGrpId, Flag: "" }
                );
                if (subGroupResponse.data.Status === 0) {
                  setSubGrpdrp(subGroupResponse.data.Data);

                  const itemsResponse = await axiosInstance.post(
                    'MstItm/GetMstItmdrp',
                    { ItmSubGrpId: selectedRow.ItmSubGrpId }
                  );
                  if (itemsResponse.data.Status === 0) {
                    setItmDrp(itemsResponse.data.Data);
                  }
                }
              }
            } catch (error) {
              console.error("Error populating dropdowns:", error);
            }
          };
          populateDropdowns();
        }
      }
    }
  }, [IndexofSelect, TableData, AllTextDisabled, reset]);

  useEffect(() => {
    const quantity = parseFloat(watch("Quantity")) || 0;
    const rate = parseFloat(watch("Rate")) || 0;
    setValue("Amount", quantity * rate);
  }, [watch("Quantity"), watch("Rate"), setValue]);

  const fetchCategoryData = async () => {
    try {
      const response = await axiosInstance.post(
        "MstItmCat/GetMstItmCatdrp",
        {}
      );
      if (response.data.Status === 0) setCategoryDrp(response.data.Data);
      else toast.error('Error fetching Category data');
    } catch (error) {
      toast.error('Error fetching Category data');
    }
  };

  const fetchUnits = async () => {
    try {
      const response = await axiosInstance.post(
        "MstUnit/getMstUnitdrp",
        {

        }
      );
      if (response.data.Status === 0) {
        setUnitdrp(response.data.Data);
        // if (response.data.Data.length > 0) {
        //   setValue("UnitId", response.data.Data[0].UnitId);
        // }
      }
    } catch (error) {
      toast.error('Failed to load measurement units');
      console.log("Error getting while fetching unit from drp");
    }
  };

  const handleCategoryChange = async (e) => {
    setValue("ItmCatId", e.target.value);
    setCategorySelected(true);

    try {
      const response = await axiosInstance.post(
        "MstItmGrp/GetMstItmGrpdrp",
        {
          ItmCatId: e.target.value,
          Flag: ""
        }
      );
      if (response.data.Status === 0) {
        setGroupDrp(response.data.Data);
        if (response.data.Data.length > 0) {
          setValue("ItmGrpId", response.data.Data[0].ItmGrpId);
          handleGroupChange({ target: { value: response.data.Data[0].ItmGrpId } });
        }
      } else toast.error('Error fetching Group data');
    } catch (error) {
      toast.error('Error fetching Group data');
    }
  };

  const handleGroupChange = async (e) => {
    setValue("ItmGrpId", e.target.value);
    console.log('grop', e.target.value)
    try {
      const response = await axiosInstance.post(
        "MstItmSubGrp/GetMstItmSubGrpdrp",
        {
          ItmGrpId: e.target.value,
          Flag: ""
        }
      );
      if (response.data.Status === 0) {
        setSubGrpdrp(response.data.Data);
        if (response.data.Data.length > 0) {
          setValue("ItmSubGrpId", response.data.Data[0].ItmSubGrpId);
          handleSubGrpChange({ target: { value: response.data.Data[0].ItmSubGrpId } });
        }
      } else toast.error('Error fetching Subgroup data');
    } catch (error) {
      toast.error('Error fetching Subgroup data');
    }
  };

  const handleSubGrpChange = async (e) => {
    setValue("ItmSubGrpId", e.target.value);
    try {
      const response = await axiosInstance.post(
        'MstItm/GetMstItmdrp',
        {
          ItmSubGrpId: e.target.value,
          Flag: 'ItmCat'
        }
      );
      if (response.data.Status === 0 && response.data.Data.length > 0) {
        setItmDrp(response.data.Data);
        // const selectedItem = response.data.Data[0];
        if (InternalMode === "Add") {
          const selectedItem = response.data.Data[0];
          updateItemFields(selectedItem);
        }
        // setValue("ItmId", selectedItem.ItmId);
        // setValue("Rate", selectedItem.CurrRate || 0);
        // setValue("UnitId", selectedItem.UnitId || "");
        // setValue("Remark", selectedItem.Remark || "");
      } else {
        setItmDrp([]);
        setValue("ItmId", "");
        setValue("Rate", 0);
        setValue("UnitId", "");
        setValue("Remark", "");
        // toast.error('No items found for the selected subgroup');
      }
    } catch (error) {
      toast.error('Error fetching items for the selected subgroup');
    }
  };
  const updateItemFields = (item) => {

    setValue("ItmId", item.ItmId);
    setValue("Rate", item.CurrRate || 0);
    setValue("Remark", item.Remark || "");
    setValue("ItmCode", item.ItmCode || "");
    if (item.UnitId) {
      setValue("UnitId", item.UnitId);
    }

    if (item.ItmCatId) {
      setValue("ItmCatId", item.ItmCatId);
      setCategorySelected(true);

      axiosInstance.post("MstItmGrp/GetMstItmGrpdrp", { ItmCatId: item.ItmCatId, Flag: "" })
        .then(groupResponse => {
          if (groupResponse.data.Status === 0) {
            setGroupDrp(groupResponse.data.Data);

            if (item.ItmGrpId) {
              setValue("ItmGrpId", item.ItmGrpId);
              axiosInstance.post("MstItmSubGrp/GetMstItmSubGrpdrp", { ItmGrpId: item.ItmGrpId, Flag: "" })
                .then(subGroupResponse => {
                  if (subGroupResponse.data.Status === 0) {
                    setSubGrpdrp(subGroupResponse.data.Data);

                    if (item.ItmSubGrpId) {
                      setValue("ItmSubGrpId", item.ItmSubGrpId);
                    }
                  }
                });
            }
          }
        });
    }
  };

  // Helper function to reset item-related fields
  const resetItemFields = () => {
    setValue("ItmId", "");
    setValue("Rate", 0);
    setValue("UnitId", "");
    setValue("Remark", "");
    setValue("ItmCatId", "");
    setValue("ItmGrpId", "");
    setValue("ItmSubGrpId", "");
    setCategorySelected(false);
  };

  const fetchGroupsForCategory = async (categoryId) => {
    try {
      const response = await axiosInstance.post(
        "MstItmGrp/GetMstItmGrpdrp",
        { ItmCatId: categoryId, Flag: "" }
      );
      if (response.data.Status === 0) {
        setGroupDrp(response.data.Data);
      }
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  const fetchSubGroupsForGroup = async (groupId) => {
    try {
      const response = await axiosInstance.post(
        "MstItmSubGrp/GetMstItmSubGrpdrp",
        { ItmGrpId: groupId, Flag: "" }
      );
      if (response.data.Status === 0) {
        setSubGrpdrp(response.data.Data);
      }
    } catch (error) {
      console.error("Error fetching subgroups:", error);
    }
  };


  const itemCategory = (e) => {
    const selectedItmId = e.target.value;
    setValue("ItmId", selectedItmId);
    const selectedItem = ItmDrp.find((item) => item.ItmId === selectedItmId);
    if (selectedItem) {
      setValue("Rate", selectedItem.CurrRate || 0);
      setValue("UnitId", selectedItem.UnitId || "");
      setValue("Remark", selectedItem.Remark || "");
    }
  };

  const handleClickAdd = () => {
    setInternalMode("Add");
    setAllTextDisabled(false);
    reset({ ItmCatId: "", ItmGrpId: "", ItmSubGrpId: "", ItmId: "", Quantity: "", Rate: "0.00", Amount: "0.00", UnitId: "", Remark: "", setSelectedProperty: '' });
    setIndexofSelect(-1);
    setAllButtonDisabled(true);
    setAddDisabled(true);
    setCategorySelected(false);
    fetchAllItems()
  };

  const handleClickEdit = () => {
    if (IndexofSelect >= 0) {
      setInternalMode("Edit");
      setAllTextDisabled(false);
      setAllButtonDisabled(true);
      setAddDisabled(true);
    }
  };

  const handleRowClick = (rowIndex) => {
    const selectedRow = TableData[rowIndex];
    setIndexofSelect(rowIndex);
    setAllButtonDisabled(false);
    setAddDisabled(false);
    setAllTextDisabled(true);
    setCategorySelected(true);
    reset({
      ItmCatId: selectedRow.ItmCatId,
      ItmGrpId: selectedRow.ItmGrpId,
      ItmSubGrpId: selectedRow.ItmSubGrpId,
      ItmId: selectedRow.ItmId,
      Quantity: selectedRow.Quantity,
      Rate: selectedRow.Rate,
      Amount: selectedRow.Amount,
      UnitId: selectedRow.UnitId,
      Remark: selectedRow.Remark,
    });


    setGroupDrp(GroupDrp.filter(g => g.ItmCatId === selectedRow.ItmCatId));
    setSubGrpdrp(SubGrpdrp.filter(s => s.ItmGrpId === selectedRow.ItmGrpId));
    setItmDrp(ItmDrp.filter(i => i.ItmSubGrpId === selectedRow.ItmSubGrpId));
  };

  const handleClickConfirm = () => {
    const formData = watch();
    console.log("formDatagrn",formData);
    const requiredFields = ["ItmCatId", "ItmGrpId", "ItmSubGrpId", "ItmId", "UnitId"];
    const currentUnitId = formData.UnitId || (Unitdrp.length > 0 ? Unitdrp[0].UnitId : "");
    if (requiredFields.some(field => {
      if (field === "UnitId") {
        return !currentUnitId;
      }
      return !formData[field];
    })) {
      toast.error("Please fill all required fields");
      return;
    }
    const quantity = parseFloat(formData.Quantity);
    if (isNaN(quantity) || quantity <= 0) {
      toast.error("Quantity must be greater than zero");
      return;
    }
    // const selectedUnit = Unitdrp.find(unit => unit.UnitId === parseInt(formData.UnitId));
    const selectedItem = ItmDrp.find(item => item.ItmId === formData.ItmId);
    const selectedCategory = CategoryDrp.find(cat => cat.ItmCatId === formData.ItmCatId);
    const selectedGroup = GroupDrp.find(grp => grp.ItmGrpId === formData.ItmGrpId);
    const selectedSubGroup = SubGrpdrp.find(sub => sub.ItmSubGrpId === formData.ItmSubGrpId);
    const selectedUnit = Unitdrp.find(unit => unit.UnitId === parseInt(formData.UnitId));
    const unitName = selectedUnit ? selectedUnit.UnitName : "";
    console.log('selevcted', selectedUnit?.UnitName)
    const newItem = {
      ...formData,
      SgrnItmId: InternalMode === "Edit" && TableData[IndexofSelect]?.SgrnItmId ? TableData[IndexofSelect].SgrnItmId : 0,
      // ItmCatId: formData.ItmCatId,
      // ItmGrpId: formData.ItmGrpId,
      // ItmSubGrpId: formData.ItmSubGrpId,
      // ItmId: formData.ItmId,
      ItmCat: selectedCategory,
      ItmGrp: selectedGroup,
      ItmSubGrp: selectedSubGroup,
      Itm: selectedItem,
      Unit: selectedUnit,
      ItmCatName: CategoryDrp.find(c => c.ItmCatId === formData.ItmCatId)?.ItmCatName || "",
      UnitName: selectedUnit?.UnitName || "",
      ItmGrpName: GroupDrp.find(g => g.ItmGrpId === formData.ItmGrpId)?.ItmGrpName || "",
      ItmSubGrpName: SubGrpdrp.find(s => s.ItmSubGrpId === formData.ItmSubGrpId)?.ItmSubGrpName || "",
      ItmName: ItmDrp.find(i => i.ItmId === formData.ItmId)?.ItmName || "",
      // Quantity: parseFloat(formData.Quantity) || 0,
      Quantity: quantity,
      Rate: parseFloat(formData.Rate) || 0,
      Amount: parseFloat(formData.Amount) || 0,
      UnitId: parseInt(formData.UnitId),
      DBFLAG: InternalMode === "Add" ? "I" : TableData[IndexofSelect]?.DBFLAG === "I" ? "I" : "U",
      Status: "1"
    };

    if (InternalMode === "Add") {
      if (!TableData.some(item => item.ItmId === newItem.ItmId && item.DBFLAG !== "D")) {
        setTableData([...TableData, newItem]);
      } else {
        toast.error("Duplicate item detected");
        return;
      }
    } else {
      const updatedTableData = [...TableData];
      updatedTableData[IndexofSelect] = newItem;
      setTableData(updatedTableData);
    }

    setAddDisabled(false);
    setAllButtonDisabled(false);
    setAllTextDisabled(true);
    setIndexofSelect(TableData.length > 0 ? 0 : -1);
    setValue("UnitId", formData.UnitId);
  };

  const handleClickCancel = () => {
    setAllButtonDisabled(false);
    setAllTextDisabled(true);
    reset({ ItmCatId: "", ItmGrpId: "", ItmSubGrpId: "", ItmId: "", Quantity: 1, Rate: "0.00", Amount: "0.00", UnitId: "", Remark: "" });
    setIndexofSelect(TableData.length > 0 ? 0 : -1);
    setAddDisabled(false);
  };



  const handleDelete = () => {
    if (IndexofSelect >= 0) setOpenDialog(true);
  };

  const handleConfirmDelete = () => {
    const updatedTableData = [...TableData];
    const itemFlag = updatedTableData[IndexofSelect].DBFLAG;
    if (itemFlag === "U" || itemFlag === "R") {
      updatedTableData[IndexofSelect].DBFLAG = "D";
    } else {
      updatedTableData.splice(IndexofSelect, 1);
    }
    setTableData(updatedTableData);
    setOpenDialog(false);
    setIndexofSelect(updatedTableData.length > 0 ? 0 : -1);
    setAllButtonDisabled(false);
    setAddDisabled(false);
    setAllTextDisabled(true);
  };

  const handleSubmit = async () => {
    if (!AllTextDisabled) {
      toast.info("Please confirm or cancel the current operation");
      return;
    }

    if (TableData.length === 0) {
      toast.error("Please add at least one item before submitting");
      return;
    }

    TextDisabledFast(true);
    const totalAmount = TableData.reduce((sum, item) => sum + (parseFloat(item.Amount) || 0), 0);
    const totalQuantity = TableData.reduce((sum, item) => sum + (parseFloat(item.Quantity) || 0), 0);
    const payload = {
      DBFLAG: mode === "add" ? "I" : "U",
      SgrnId: mode === "edit" ? GooodsId : 0,
      SgrnNo: AllfieldStepperData.SgrnNo || `S${Date.now()}`,
      SgrnDt: AllfieldStepperData.SgrnDt || new Date().toISOString(),
      RefNo: AllfieldStepperData.RefNo || "",
      PartyId: AllfieldStepperData.PartyId,
      PartyDtlId: AllfieldStepperData.PartyDtlId,
      ActVendId: AllfieldStepperData.ActualPartyId || 1,
      PropId: AllfieldStepperData?.PropertyId || "1",
      ActVendDtlId: AllfieldStepperData.ActualPartyDtlId || 1,
      ChallanNo: AllfieldStepperData.ChallanNo || "",
      ChallanDt: AllfieldStepperData.ChallanDt || new Date().toISOString(),
      TrspId: AllfieldStepperData.TrspId || 1,
      LrNo: AllfieldStepperData.LrNo || "",
      LrDt: AllfieldStepperData.LrDt || new Date().toISOString(),
      BrokerId: AllfieldStepperData.BrokerId || 1,
      Remark: AllfieldStepperData.Remark || "",
      Amount: totalAmount,
      Quantity: totalQuantity,
      Status: "1",
      CreatedBy: parseInt(UserLoginId),
      // ActVendId: AllfieldStepperData.ActVendId || 1,
      UpdatedBy: parseInt(UserLoginId),
      TrnSgrnItmList: TableData.map(item => ({
        DBFLAG: item.DBFLAG || "I",
        SgrnItmId: item.SgrnItmId || 0,
        SgrnId: mode === "edit" ? GooodsId : 0,
        ItmId: parseInt(item.ItmId),
        UnitId: parseInt(item.UnitId),
        ItmCatId: parseInt(item.ItmCatId),
        ItmGrpId: parseInt(item.ItmGrpId),
        ItmSubGrpId: parseInt(item.ItmSubGrpId),
        Quantity: parseFloat(item.Quantity) || 0,
        Rate: parseFloat(item.Rate) || 0,
        Amount: parseFloat(item.Amount) || 0,
        DiscAmt: 0,
        NetAmt: parseFloat(item.Amount) || 0,
        Remark: item.Remark || "",
        Status: 1
      }))
    };
    console.log("Payload before sending:", payload);
    let FormattedObj = JSON.stringify(payload).replace(/"/g, '\\"');
    FormattedObj = '"' + FormattedObj + '"';
    try {
      const response = await axiosInstance.post("TrnSgrn/ManageTrnSgrnItm", FormattedObj);
      if (response.data.Status === 0) {
        toast.success(response.data.Message || "Record saved successfully");
        if (mode === "edit") await UnLock(GooodsId, "TrnSgrn", "SgrnId");
        fetchGoodsData(mode === "add" ? 1 : GooodsId, mode === "add" ? "L" : "R");
        setActiveStep(0);
        viewModeDis();
      } else {
        toast.error(response.data.Message || "Submission failed");
      }
    } catch (error) {
      console.error("Submission error:", error.response?.data || error.message);
      toast.error("Error submitting data: " + (error.response?.data?.message || error.message));
    } finally {
      TextDisabledFast(false);
    }
  };
  const handlePreviousClick = () => {
    if (!AllTextDisabled) {
      toast.info("Please Confirm or Cancel the current operation");
      return;
    }
    if (mode !== "view") {
      addModeDis();
      setFlag(true);
    }
    setActiveStep(0);
  };
  const handleClickCancelButton = async () => {
    if (!AllTextDisabled) {
      toast.info("Please Confirm or Cancel the current operation");
      return;
    }
    if (mode === "edit" && GooodsId !== -1) {
      await UnLock(GooodsId, "TrnSgrn", "SgrnId");
    }
    fetchGoodsData(GooodsId !== -1 ? GooodsId : 1, GooodsId !== -1 ? "R" : "L");
    setActiveStep(0);
    viewModeDis();
  };
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const response = await getRoomMasterdropdata({
          Flag: "",
          UserId: userId,
        });
        if (response?.data?.Status === 0) {
          const dropdownItems = response.data.Data.map((item) => ({
            id: item.PropId,
            name: item.Name,
          }));
          setPropoption(dropdownItems);
          if (dropdownItems.length > 0) {
            setSelectedProperty(dropdownItems[0]);
          }
        }
      } catch (error) {
        toast.error("Error fetching property data");
      }
    };

    fetchDropdownData();
  }, [userId]);
  const fetchAllItems = async (searchTerm = "") => {
    try {
      const response = await axiosInstance.post(
        'MstItm/GetMstItmdrp',
        {
          SearchTerm: searchTerm,
          Flag: 'All'
        }
      );
      if (response.data.Status === 0) {
        setItmDrp(response.data.Data);
      } else {
        setItmDrp([]);
      }
    } catch (error) {
      console.error("Error fetching items:", error);
      toast.error('Error fetching items');
    }
  };
  const fetchLastRate = async (itemId) => {
    try {
      const response = await axiosInstance.get(
        `TrnSgrn/GetLast5TransactionsByItem?ItmId=${itemId}`
      );

      if (response.data.Status === 0) {
        setLastRateData(response.data.Data);
        setLastRate(response.data.Data[0]?.Rate || 'No rate found');
        handleOpenDialog();
      } else {
        toast.error("No previous rates found");
      }
    } catch (error) {
      console.error("Error fetching last rates:", error);
      toast.error("Error fetching last rates");
    }
  };
  return (
    <Grid container spacing={2}>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to delete this record?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button sx={{ backgroundColor: '#635bff', color: 'white', '&:hover': { backgroundColor: '#1565c0' } }} onClick={handleConfirmDelete}>Yes</Button>
          <Button sx={{ backgroundColor: '#635bff', color: 'white', '&:hover': { backgroundColor: '#1565c0' } }} onClick={() => setOpenDialog(false)}>No</Button>
        </DialogActions>
      </Dialog>

      <Grid item xs={12}>
        <Paper sx={{ width: "96%", overflow: "hidden", margin: "0px 0px 0px 15px", border: "1px solid lightgray" }}>
          <TableContainer sx={{ maxHeight: 450 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow sx={{ "& > th": { padding: "0px 10px" } }}>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                      <Typography variant="subtitle1" fontWeight="bold">{column.label}</Typography>
                      <TextField
                        variant="outlined"
                        size="small"
                        placeholder={`Search ${column.label}`}
                        value={columnFilters[column.id] || ""}
                        onChange={(e) => {
                          setColumnFilters({
                            ...columnFilters,
                            [column.id]: e.target.value
                          });
                        }}
                        sx={{

                          "& .MuiOutlinedInput-root": {
                            height: 23,
                            fontSize: '0.8rem',
                            paddingLeft: '2px',
                            width: '100px'
                          }
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon fontSize="small" />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {filterTableData(TableData)?.map((row, index) => (
                  <TableRow hover key={index}
                    sx={{
                      "& > td": { padding: "2px 14px" },
                      cursor: "pointer",
                      backgroundColor: IndexofSelect === index ? '#e3f2fd' : 'inherit',
                      '&:hover': {
                        backgroundColor: IndexofSelect === index ? '#e3f2fd' : '#f5f5f5',
                      }
                    }}
                    onClick={() => handleRowClick(index)}>
                    {columns.map((column) => (
                      <TableCell key={column.id} align={column.align}>
                        {row[column.id] || "N/A"}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Grid>

      <Grid item xs={12} sx={{
        display: "flex",
        gap: "12px",
        alignItems: "center",
        marginTop: "0px",
        justifyContent: "flex-start",
        marginLeft: '15px',
      }}>
        <Button
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          onClick={handleClickAdd}
          disabled={AddDisabled || IsButtonSubmit}
          sx={{
            backgroundColor: "#635bff",
            color: "white",
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 500,
            padding:'2px 8px',
            minWidth: "50px",
            boxShadow: "0 2px 4px rgba(99, 91, 255, 0.2)",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "#4a42d1",
              transform: "translateY(-1px)",
              boxShadow: "0 4px 8px rgba(99, 91, 255, 0.3)"
            },
            "&:active": {
              transform: "translateY(0)"
            },
            "&.Mui-disabled": {
              backgroundColor: "#e0e0e0",
              color: "#a0a0a0"
            }
          }}
        >
          Add
        </Button>
        <Button
          variant="outlined"
          size="small"
          startIcon={<EditIcon />}
          disabled={AllButtonDisabled || IsButtonSubmit}
          onClick={handleClickEdit}
          sx={{
            borderColor: "#635bff",
            color: "#635bff",
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 500,
            padding:'2px 8px',
            minWidth: "50px",
            boxShadow: "none",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "rgba(99, 91, 255, 0.08)",
              borderColor: "#4a42d1",
              color: "#4a42d1",
              transform: "translateY(-1px)",
              boxShadow: "0 2px 4px rgba(99, 91, 255, 0.2)"
            },
            "&:active": {
              transform: "translateY(0)"
            },
            "&.Mui-disabled": {
              borderColor: "#e0e0e0",
              color: "#a0a0a0"
            }
          }}
        >
          Edit
        </Button>
        <Button
          variant="contained"
          size="small"
          startIcon={<DeleteIcon />}
          disabled={AllButtonDisabled || IsButtonSubmit}
          onClick={handleDelete}
          sx={{
            backgroundColor: "#ff4444",
            color: "white",
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 500,
            padding:'2px 8px',
            minWidth: "50px",
            boxShadow: "0 2px 4px rgba(255, 68, 68, 0.2)",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "#cc0000",
              transform: "translateY(-1px)",
              boxShadow: "0 4px 8px rgba(255, 68, 68, 0.3)"
            },
            "&:active": {
              transform: "translateY(0)"
            },
            "&.Mui-disabled": {
              backgroundColor: "#e0e0e0",
              color: "#a0a0a0"
            }
          }}
        >
          Delete
        </Button>
      </Grid>
      <Grid container spacing={2} sx={{
        width: "95%",
        margin: "8px auto 0",
        padding: "14px",
        backgroundColor: "white",
        borderRadius: "12px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
      }}>
        <Grid item xs={12}>
          <Box display="flex" flexDirection="column" gap={3}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Item code"
                  name="Code"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={watch("ItmCode") || ""}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      backgroundColor: "background.paper"
                    }
                  }}
                  {...register("0")}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  id="item-autocomplete"
                  options={ItmDrp}
                  getOptionLabel={(option) => option.ItmName}
                  value={ItmDrp.find(item => item.ItmId === watch('ItmId')) || null}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      updateItemFields(newValue);
                    } else {
                      resetItemFields();
                    }
                  }}
                  disabled={AllTextDisabled}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Search Item..."
                      label={
                        <>
                          Item Description
                          <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                        </>
                      }
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon color="action" />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          // backgroundColor: AllTextDisabled ? "action.disabledBackground" : "background.paper"
                        }
                      }}
                    />
                  )}
                  isOptionEqualToValue={(option, value) => option.ItmId === value.ItmId}
                  noOptionsText="No items available"
                />
              </Grid>


              <Grid item xs={12} md={3}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="UnitId-name-select-label">
                    Unit
                    <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="UnitId-name-select-label"
                    id="UnitId"
                    name="UnitId"
                    value={watch("UnitId") || ""}
                    onChange={(e) => setValue("UnitId", e.target.value)}
                    disabled={!categorySelected || AllTextDisabled}
                    label={
                      <>
                        Unit
                        <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                      </>
                    }
                    sx={{
                      borderRadius: "8px",
                      // backgroundColor: (!categorySelected || AllTextDisabled) ? "action.disabledBackground" : "background.paper"
                    }}
                  >
                    {Unitdrp.map(obj => (
                      <MenuItem value={obj.UnitId} key={obj.UnitId}>{obj.UnitName}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="ItmCatId-select-label">
                    Category
                    <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="ItmCatId-select-label"
                    id="ItmCatId"
                    name="ItmCatId"
                    value={watch("ItmCatId") || ""}
                    onChange={handleCategoryChange}
                    disabled={AllTextDisabled}
                    label={
                      <>
                        Category
                        <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                      </>
                    }
                    sx={{
                      borderRadius: "8px",
                      // backgroundColor: AllTextDisabled ? "action.disabledBackground" : "background.paper"
                    }}
                  >
                    {CategoryDrp.map((type) => (
                      <MenuItem key={type.ItmCatId} value={type.ItmCatId}>{type.ItmCatName}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="ItmGrpId-name-select-label">
                    Group
                    <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="ItmGrpId-name-select-label"
                    id="ItmGrpId"
                    name="ItmGrpId"
                    value={watch("ItmGrpId") || ""}
                    onChange={handleGroupChange}
                    disabled={!categorySelected || AllTextDisabled}
                    label={
                      <>
                        Group
                        <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                      </>
                    }
                    sx={{
                      borderRadius: "8px",
                      // backgroundColor: (!categorySelected || AllTextDisabled) ? "action.disabledBackground" : "background.paper"
                    }}
                  >
                    {GroupDrp.map((type) => (
                      <MenuItem key={type.ItmGrpId} value={type.ItmGrpId}>{type.ItmGrpName}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="ItmSubGrpId-select-label">
                    Sub Group
                    <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="ItmSubGrpId-select-label"
                    id="ItmSubGrpId"
                    name="ItmSubGrpId"
                    value={watch('ItmSubGrpId') || ""}
                    disabled={!categorySelected || AllTextDisabled}
                    {...register("ItmSubGrpId")}
                    onChange={handleSubGrpChange}
                    label={
                      <>
                        Sub Group
                        <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                      </>
                    }
                    sx={{
                      borderRadius: "8px",
                      // backgroundColor: (!categorySelected || AllTextDisabled) ? "action.disabledBackground" : "background.paper"
                    }}
                  >
                    {SubGrpdrp.map((type) => (
                      <MenuItem key={type.ItmSubGrpId} value={type.ItmSubGrpId}>{type.ItmSubGrpName}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Model/Part Number"
                  name="Code"
                  type="text"
                  variant="outlined"
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      backgroundColor: "background.paper"
                    }
                  }}
                  {...register("0")}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} alignItems="center">

              <Grid item xs={12} md={2}>
                <TextField
                  fullWidth
                  label={
                    <span>
                      Quantity
                      <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="outlined"
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      // backgroundColor: AllTextDisabled ? "action.disabledBackground" : "background.paper"
                    }
                  }}
                  {...register("Quantity")}
                  value={watch("Quantity")}
                  // onChange={(e) => setValue("Quantity", e.target.value)}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || (!isNaN(value) && parseFloat(value) > 0)) {
                      setValue("Quantity", value);
                    }
                  }}
                  error={parseFloat(watch("Quantity")) <= 0}
                  helperText={parseFloat(watch("Quantity")) <= 0 ? "Quantity can't be zero" : ""}
                  disabled={AllTextDisabled}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  fullWidth
                  label="Rate"
                  variant="outlined"
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      // backgroundColor: AllTextDisabled ? "action.disabledBackground" : "background.paper"
                    }
                  }}
                  {...register("Rate")}
                  value={watch("Rate")}
                  onChange={(e) => setValue("Rate", e.target.value)}
                  disabled={AllTextDisabled}

                />
              </Grid>
              <Grid item xs={12} md={1}>
                <Box
                  onClick={() => fetchLastRate(watch("ItmId"))}
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    color: '#1976d2',
                    '&:hover': {
                      textDecoration: 'underline',
                    },
                    background:'#4286f4',
                    color:'white',
                    padding:'2px',
                    borderRadius:'5px',
                    mt:1
                  }}
                >
                  <InsertLinkIcon fontSize="small" sx={{ mr: 0.5 }} />
                  <Typography variant="body2" fontWeight="medium">
                    RateList
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  fullWidth
                  label="Amount"
                  variant="outlined"
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      // backgroundColor: "action.disabledBackground"
                    }
                  }}
                  {...register("Amount")}
                  value={watch("Amount") || 0}
                  disabled
                />
              </Grid>

              <Grid item xs={12} md={2} sx={{ display: "flex", gap: "11px", alignItems: "center" }}>
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    backgroundColor: "#635bff",
                    color: "white",
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: "500",
                    boxShadow: "none",
                    padding:'2px 8px',
                    "&:hover": {
                      backgroundColor: "#4a42d1",
                      boxShadow: "none"
                    }
                  }}
                  disabled={AllTextDisabled}
                  onClick={handleClickConfirm}
                >
                  Confirm
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{
                    borderColor: "#635bff",
                    color: "#635bff",
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: "500",
                    padding:'2px 8px',
                    "&:hover": {
                      borderColor: "#4a42d1",
                      color: "#4a42d1"
                    }
                  }}
                  disabled={AllTextDisabled}
                  onClick={handleClickCancel}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Remark"
                  variant="outlined"
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      // backgroundColor: AllTextDisabled ? "action.disabledBackground" : "background.paper"
                    }
                  }}
                  {...register("Remark")}
                  value={watch('Remark') || ''}
                  onChange={(e) => setValue("Remark", e.target.value)}
                  disabled={AllTextDisabled}

                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid item ref={divRef} xs={2} className="form_button" sx={{ display: "flex", gap: "10px", alignItems: "center", marginTop: "10px", marginLeft: "69vw", textAlign: "right" }}>
        {['Prev', 'Submit', 'Cancel'].map((label, index) => (
          <Button key={index} sx={{ background: 'linear-gradient(290deg, #b9d0e9, #e9f2fa)', width: "50px" }} variant="contained" onClick={label === 'Prev' ? handlePreviousClick : label === 'Submit' ? handleSubmit : handleClickCancelButton} disabled={IsButtonSubmit}>
            {label}
          </Button>
        ))}
      </Grid>
      <LastRateDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        lastRate={lastRate}
        lastRateData={lastRateData}
      />
    </Grid>
  );
};

export default GRNStep2;